var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", { staticClass: "actions d-flex" }, [
    _vm.object.status == 0 &&
    _vm.object.hasEmailLicenceFeature &&
    _vm.useDvFlagAccess("beepiz-licence-unassociated-can:create")
      ? _c(
          "span",
          { staticClass: "d-flex" },
          [
            _c(
              "Button2",
              {
                nativeOn: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleAssociate($event)
                  },
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$t("device.registrations.associate_button_label")
                    ) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        )
      : _vm.object.status == 0 && !_vm.object.hasEmailLicenceFeature
      ? _c("span", { staticClass: "d-flex" }, [
          _vm.useDvFlagAccess("beepiz-licence-unassociated-can:create")
            ? _c("i", {
                staticClass: "fa fa-send fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.sendSMS"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleSendFirstTime($event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.useDvFlagAccess("beepiz-licence-unassociated-can:create")
            ? _c("i", {
                staticClass: "fa fa-qrcode fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.sendQRCode"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleQRCode($event)
                  },
                },
              })
            : _vm._e(),
        ])
      : _vm.object.status == 1
      ? _c("span", { staticClass: "d-flex" }, [
          _vm.object.registration.type_association === "qrcode" &&
          _vm.useDvFlagAccess("beepiz-licence-unassociated-can:update")
            ? _c("i", {
                staticClass: "fa fa-qrcode fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.showQrCode"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleQRCode($event)
                  },
                },
              })
            : _vm.object.registration.type_registration !== "qrcode" &&
              _vm.useDvFlagAccess("beepiz-licence-unassociated-can:update")
            ? _c("i", {
                staticClass: "fa fa-send fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.sendAgain"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleSend($event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.useDvFlagAccess("beepiz-licence-unassociated-can:delete")
            ? _c("i", {
                staticClass: "fa fa-ban fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.cancel"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCancel($event)
                  },
                },
              })
            : _vm._e(),
        ])
      : _vm.object.status == 3
      ? _c("span", { staticClass: "d-flex" }, [
          _vm.useDvFlagAccess("beepiz-licence-unassociated-can:update")
            ? _c("i", {
                staticClass: "fa fa-send fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.sendAgain"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleSend($event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.useDvFlagAccess("beepiz-licence-unassociated-can:delete")
            ? _c("i", {
                staticClass: "fa fa-ban fa-fw",
                attrs: {
                  title: _vm.$t("device.registrations.tooltips.cancel"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCancel($event)
                  },
                },
              })
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }